module.exports = __webpack_public_path__ + "static/media/2024_16.4aabf5af.jpg";